<template>
    <div
        class="relative flex items-center w-full col-span-1 px-4 py-6 mb-4 bg-white border border-gray-200 shadow-sm rounded-"
    >
        <div
            @click="show = !show"
            class="absolute top-0 right-0 flex items-center justify-center w-8 h-8 text-gray-500 border-b border-l border-gray-100 cursor-pointer hover:text-gray-900"
        >
            <svg
                v-show="show"
                class="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 9l-7 7-7-7"
                ></path>
            </svg>
            <svg
                v-show="!show"
                class="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 15l7-7 7 7"
                ></path>
            </svg>
        </div>
        <div class="w-full px-4 mx-auto sm:px-6 lg:px-8">
            <div class="max-w-4xl mx-auto">
                <div class="flex justify-between" v-show="show">
                    <h2
                        ref="scrollToMe"
                        @click="show = !show"
                        class="text-xl font-extrabold leading-9 text-left text-blue-600 cursor-pointer sm:text-xl sm:leading-10"
                    >
                        {{ techInstallation.designation }}
                    </h2>
                    <div @click="removeInstallationTech">
                        <base-icon
                            width="60"
                            height="60"
                            class="h-8 cursor-pointer"
                            icon-name="trash"
                            viewBox="0 0 20 20 "
                            iconColor="#6C98C6"
                        >
                            <icon-trash />
                        </base-icon>
                    </div>
                </div>
                <div v-show="!show">
                    <tag-group :tags="tags" @clicked="changeIsBuyingType" />
                    <base-input
                        placeholder="Désignation"
                        v-model="techInstallation.designation"
                        :hasError="$v.techInstallation.designation.$error"
                        :errorMessage="
                            errorMessage(
                                'Désignation',
                                $v.techInstallation.designation
                            )
                        "
                        @blur="$v.techInstallation.designation.$touch()"
                    />
                    <base-number-input
                        label="Quantité"
                        placeholder="0"
                        v-model="techInstallation.number"
                        :hasError="$v.techInstallation.number.$error"
                        :errorMessage="
                            errorMessage('Nombre', $v.techInstallation.number)
                        "
                        @blur="$v.techInstallation.number.$touch()"
                    />
                    <base-input
                        placeholder="Caractéristiques"
                        v-model="techInstallation.characteristics"
                        :hasError="$v.techInstallation.characteristics.$error"
                        :errorMessage="
                            errorMessage(
                                'Caractéristiques',
                                $v.techInstallation.characteristics
                            )
                        "
                        @blur="$v.techInstallation.characteristics.$touch()"
                    />
                    <div class="mt-10 ml-3 text-left">
                        <label
                            class="block my-2 mb-2 text-sm font-normal leading-5 tracking-wide text-gray-600 sm:font-normal sm:text-base sm:leading-10"
                            >État</label
                        >
                        <radio-box
                            label="Neuf"
                            name="buyingOrRent"
                            :value="techInstallation.state"
                            @change="
                                payload => {
                                    techInstallation.state = payload;
                                }
                            "
                        />
                        <radio-box
                            class="ml-6"
                            label="Occasion"
                            name="buyingOrRent"
                            :value="techInstallation.state"
                            @change="
                                payload => {
                                    techInstallation.state = payload;
                                }
                            "
                        />
                    </div>
                    <base-number-input
                        :isCurrency="true"
                        label="Prix Unitaire (HT)"
                        placeholder="0"
                        v-model="techInstallation.price"
                        :hasError="$v.techInstallation.price.$error"
                        :errorMessage="
                            errorMessage('Prix', $v.techInstallation.price)
                        "
                        @blur="$v.techInstallation.price.$touch()"
                    />

                    <base-input
                        placeholder="Nom du fournisseur"
                        v-model="techInstallation.providerName"
                        :hasError="$v.techInstallation.providerName.$error"
                        :errorMessage="
                            errorMessage(
                                'Nom du fournisseur',
                                $v.techInstallation.providerName
                            )
                        "
                        @blur="$v.techInstallation.providerName.$touch()"
                    />

                    <div class="mt-10 ml-3 text-left">
                        <label
                            class="block my-2 mb-2 text-sm font-normal leading-5 tracking-wide text-gray-600 sm:font-normal sm:text-base sm:leading-10"
                            >Origine</label
                        >
                        <radio-box
                            label="Local"
                            name="origine"
                            :value="techInstallation.origin"
                            @change="
                                payload => {
                                    techInstallation.origin = payload;
                                }
                            "
                        />
                        <radio-box
                            class="ml-6"
                            label="Étranger"
                            name="origine"
                            :value="techInstallation.origin"
                            @change="
                                payload => {
                                    techInstallation.origin = payload;
                                }
                            "
                        />
                    </div>
                    <base-tips-alert
                        v-if="!techInstallation.isBuying"
                        color="bg-orange-100 border-orange-400"
                        title="Attention"
                    >
                        <p class="my-0 mt-1 text-gray-700">
                            Veuillez contacter votre banquier pour avoir la
                            simulation de votre crédit de bail.
                        </p>
                    </base-tips-alert>
                    <base-number-input
                        :isCurrency="true"
                        label="Avance (HT)"
                        placeholder="0"
                        v-if="!techInstallation.isBuying"
                        v-model="techInstallation.payedInAdvance"
                        :hasError="$v.techInstallation.payedInAdvance.$error"
                        :errorMessage="
                            errorMessage(
                                'Avance en DHs (HT)',
                                $v.techInstallation.payedInAdvance
                            )
                        "
                        @blur="$v.techInstallation.payedInAdvance.$touch()"
                    />
                    <base-number-input
                        label="Loyer mensuel (HT)"
                        :isCurrency="true"
                        placeholder="0"
                        v-if="!techInstallation.isBuying"
                        v-model="techInstallation.rentPrice"
                        :hasError="$v.techInstallation.rentPrice.$error"
                        :errorMessage="
                            errorMessage(
                                'Loyer mensuel (HT)',
                                $v.techInstallation.rentPrice
                            )
                        "
                        @blur="$v.techInstallation.rentPrice.$touch()"
                    />
                    <base-number-input
                        label="Nombre de mois"
                        placeholder="0"
                        v-if="!techInstallation.isBuying"
                        v-model="techInstallation.rentDuration"
                        :hasError="$v.techInstallation.rentDuration.$error"
                        :errorMessage="
                            errorMessage(
                                'Nombre de mois',
                                $v.techInstallation.rentDuration
                            )
                        "
                        @blur="$v.techInstallation.rentDuration.$touch()"
                    />

                    <div class="flex justify-end mt-4">
                        <base-secondary-button
                            color="red"
                            title="Supprimer"
                            @click="removeInstallationTech"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RadioBox from "@/components/forms/Toggles/radioBox";
import TagGroup from "@/components/forms/TagGroup";
import IconTrash from "@/components/icons/trash";
import {
    required,
    integer,
    decimal,
    minValue,
    minLength,
    maxLength
} from "vuelidate/lib/validators";
import { errorMessage } from "@/mixins/errorMessage.js";
import { scrollToRef } from "@/mixins/scrollToMixin.js";

export default {
    components: { RadioBox, TagGroup, IconTrash },
    props: {
        data: {
            type: Object
        },

        title: {
            type: String
        }
    },

    mixins: [errorMessage, scrollToRef],

    validations() {
        if (this.techInstallation.isBuying) {
            return {
                techInstallation: {
                    price: { required, decimal, minValue: minValue(0) },
                    designation: {
                        minLength: minLength(3),
                        maxLength: maxLength(75)
                    },
                    number: { integer, minValue: minValue(1) },
                    characteristics: {
                        minLength: minLength(3),
                        maxLength: maxLength(150)
                    },
                    providerName: {
                        minLength: minLength(3),
                        maxLength: maxLength(75)
                    }
                }
            };
        } else {
            return {
                techInstallation: {
                    price: { required, decimal, minValue: minValue(0) },
                    rentPrice: { required, decimal, minValue: minValue(0) },
                    rentDuration: { required, integer, minValue: minValue(0) },
                    payedInAdvance: {
                        required,
                        decimal,
                        minValue: minValue(0)
                    },
                    designation: {
                        minLength: minLength(3),
                        maxLength: maxLength(75)
                    },
                    number: { integer, minValue: minValue(1) },
                    characteristics: {
                        minLength: minLength(3),
                        maxLength: maxLength(150)
                    },
                    providerName: {
                        minLength: minLength(3),
                        maxLength: maxLength(75)
                    }
                }
            };
        }
    },

    data() {
        return {
            show: false,
            techInstallation: this.data,
            name: "Installations techniques ",
            tags: [
                {
                    name: "Achat en propriété",
                    value: "achat",
                    isActive: false
                },
                { name: "Achat en leasing", value: "leasing", isActive: false }
            ]
        };
    },
    mounted() {
        this.tags.forEach(elem => {
            if (
                elem.value ===
                (this.techInstallation.isBuying ? "achat" : "leasing")
            )
                elem.isActive = true;
        });
    },
    methods: {
        changeIsBuyingType(newValue) {
            this.techInstallation.isBuying =
                newValue === "achat" ? true : false;
        },
        createInstallationTech() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.$store.dispatch(
                    "EtudeTechnique/createInstallationTech",
                    this.techInstallation
                );
                this.show = true;
                return true;
            } else {
                this.show = false;
                return false;
            }
        },
        removeInstallationTech() {
            this.$emit("remove", this.techInstallation.id);
        }
    }
};
</script>

<style></style>
